import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { requestSpaceContents } from '../../actions/spaces/RequestSpaceContentsActions';
import { updateBreadcrumbs } from '../../actions/UpdateBreadcrumbsAction';
import { selectContentTotalLength } from '../../selectors/ContentSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { AllServerUsersSpace, AllServerUsersSpaceDispatchProps, AllServerUsersSpaceOwnProps, AllServerUsersSpaceStateProps } from './AllServerUsersSpace';

const mapStateToProps: MapStateToProps<AllServerUsersSpaceStateProps> = (state: AppState) => ({
  numberOfFetchedUsers: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
});

const mapDispatchToProps: MapDispatchToProps<AllServerUsersSpaceDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents,
  updateBreadcrumbs
}, dispatch);

export const ConnectedAllServerUsersSpace: React.ComponentClass<AllServerUsersSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(AllServerUsersSpace);
